module.exports = __webpack_public_path__ + "static/media/metalPin.e7bacba4.png";